import React from 'react'

import RequestAssetsSection from '../../../ReusableSections/RequestAssetsSection'
import ActionsOrCommentsSection from '../../../ReusableSections/ActionsOrCommentsSection'
import DigitalCampaignDatesSection from '../../../ReusableSections/DigitalCampaignDatesSection'
import DigitalRightCreateAllocationSection from '../sections/DigitalRightCreateAllocationSection'

function DigitalRightCreateSections({ formik }) {
  return (
    <>
      <DigitalCampaignDatesSection formik={formik} />
      <DigitalRightCreateAllocationSection formik={formik} />
      <RequestAssetsSection formik={formik} />
      <ActionsOrCommentsSection formik={formik} />
    </>
  )
}

export default DigitalRightCreateSections
